import React from 'react';
import { Button } from '../components/Button';
import { useNavigate } from 'react-router-dom';

export function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="flex items-center justify-center min-h-[60vh] p-4">
            <div className="text-center animate-fade-in">
                <img src="/rt-logo.png" alt="" className="w-16 h-16 mx-auto mb-6 rounded-lg opacity-40" />
                <h1 className="text-6xl font-bold text-accent-500 mb-2">404</h1>
                <h2 className="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-2">Page Not Found</h2>
                <p className="text-slate-500 dark:text-slate-400 mb-6">The page you're looking for doesn't exist.</p>
                <Button onClick={() => navigate('/dashboard')}>Go to Dashboard</Button>
            </div>
        </div>
    );
}
